import React from "react";

type Props={
    ios:boolean;
};

export default function AvaLighting({ios}:Props){

return(
<>

    {/* Ambient */}

    <ambientLight
        intensity={ios ? 0.82 : 1.90}
    />

    {/* Key */}

    <directionalLight
        position={[1.8,2.6,3.4]}
        intensity={ios ? 1.00 : 2.80}
        color="#dff8ff"
    />

    {/* Fill */}

    <directionalLight
        position={[-2.5,1.3,1.8]}
        intensity={ios ? 0.40 : 1.35}
        color="#8fdfff"
    />

    {/* Rim */}

    <directionalLight
        position={[0.0,2.8,-3.5]}
        intensity={ios ? 0.55 : 1.70}
        color="#78d8ff"
    />

    {/* Chin lift */}

    <pointLight
        position={[0,-0.9,1.4]}
        intensity={ios ? 0.20 : 0.65}
        distance={4}
        color="#d9fbff"
    />

</>
);

}
